export function getNodeName(fullName: string): string {
    const indexOfLastSlash = fullName.lastIndexOf('/');
    if (indexOfLastSlash == -1) {
        return fullName;
    }

    return fullName.substring(indexOfLastSlash + 1);
}